export default __webpack_public_path__ + "static/media/mobMenuLogo.6c507cf8.svg";